<template>
  <div 
    v-if="isVisible"
    ref="menu"
    class="context-menu bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-lg shadow-lg"
    :style="menuPosition"
  >
    <div class="context-menu__items">
      <menu-item
        icon="edit"
        :label="$t('HELP_CENTER.CATEGORY.CONTEXT_MENU.EDIT')"
        @click="$emit('edit')"
      />
      <menu-item
        v-if="!isFirstItem"
        icon="arrow-up"
        :label="$t('HELP_CENTER.CATEGORY.CONTEXT_MENU.MOVE_TOP')"
        @click="$emit('move-top')"
      />
      <menu-item
        icon="delete"
        :label="$t('HELP_CENTER.CATEGORY.CONTEXT_MENU.DELETE')"
        variant="danger"
        @click="$emit('delete')"
      />
    </div>
  </div>
</template>

<script>
import MenuItem from '../../../../../components/layout/sidebarComponents/groups/MenuItem.vue';

export default {
  components: { MenuItem },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    position: {
      type: Object,
      default: () => ({ x: 0, y: 0 })
    },
    isFirstItem: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    menuPosition() {
      const viewport = {
        width: window.innerWidth,
        height: window.innerHeight
      };

      const menuWidth = 160;
      const menuHeight = 150;

      let left = this.position.x;
      let top = this.position.y;

      if (left + menuWidth > viewport.width) {
        left = viewport.width - menuWidth - 10;
      }

      if (top + menuHeight > viewport.height) {
        top = viewport.height - menuHeight - 10;
      }

      return {
        top: `${top}px`,
        left: `${left}px`
      };
    }
  },
  methods: {
    handleClickOutside(event) {
      if (this.$refs.menu && !this.$refs.menu.contains(event.target)) {
        this.$emit('close');
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style lang="scss" scoped>
.context-menu {
  position: fixed;
  z-index: 999;
  min-width: 160px;
}
</style>
